import type React from "react"

interface AssessmentProgressProps {
  currentQuestion: number
  totalQuestions: number
}

export const AssessmentProgress: React.FC<AssessmentProgressProps> = ({ currentQuestion, totalQuestions }) => {
  const progress = (Math.min(currentQuestion, totalQuestions) / totalQuestions) * 100

  return (
    <div className="bg-white rounded-2xl p-6 mb-8 shadow-sm border border-slate-200">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-slate-900">Your Progress</h3>
        <span className="text-sm font-medium text-slate-600">
          Question {Math.min(currentQuestion, totalQuestions)} of {totalQuestions}
        </span>
      </div>
      <div className="w-full bg-slate-200 rounded-full h-3">
        <div
          className="h-3 rounded-full bg-indigo-600 transition-all duration-500 ease-out"
          style={{ width: `${progress}%` }}
        />
      </div>
      <div className="flex justify-between text-xs text-slate-500 mt-3">
        <span>Start</span>
        <span>Halfway</span>
        <span>Finish</span>
      </div>
    </div>
  )
}
